@if (presentation() === 'detail') {
    <div
        class="grid min-w-0 grid-cols-[auto_minmax(0,1fr)] items-start gap-2 [line-height:20px]"
        [attr.aria-label]="resolvedAriaLabel()"
    >
        <ng-icon qpx size="sm" [name]="icon()" class="mt-2 shrink-0" />
        <div class="min-w-0">
            <p qpxCell="secondary" tone="muted" variant="sm" class="m-0">
                {{ label() }}
            </p>
            <div class="flex min-w-0 items-center gap-1">
                <p qpxCell class="m-0 min-w-0 break-words text-table-cell-sm">
                    {{ value() }}
                </p>

                @if (trailingIcon()) {
                    <qpx-pill
                        size="sm"
                        [icon]="trailingIcon() ?? ''"
                        [label]="resolvedTrailingIconLabel()"
                        [context]="resolvedTrailingIconContext()"
                        tone="muted"
                        [decorative]="true"
                        [darkenIconBackground]="true"
                        [iconOnly]="true"
                        [qpxTooltip]="trailingIconLabel()"
                        matTooltipPosition="above"
                    />
                }
            </div>
        </div>
    </div>
} @else {
    <span
        qpxCell="secondary"
        tone="muted"
        variant="sm"
        class="inline-flex min-w-0 items-center gap-1 [line-height:20px]"
        [attr.aria-label]="resolvedAriaLabel()"
    >
        <ng-icon
            qpx
            size="sm"
            [name]="icon()"
            class="shrink-0"
            [class.self-start]="wrap()"
            [class.mt-0.5]="wrap()"
            [qpxTooltip]="label()"
        />
        <span
            class="min-w-0"
            [class.truncate]="!wrap()"
            [class.whitespace-pre-wrap]="wrap()"
            [class.wrap-anywhere]="wrap()"
            >{{ value() }}</span
        >

        @if (trailingIcon()) {
            <qpx-pill
                size="sm"
                [icon]="trailingIcon() ?? ''"
                [label]="resolvedTrailingIconLabel()"
                [context]="resolvedTrailingIconContext()"
                tone="muted"
                [decorative]="true"
                [darkenIconBackground]="true"
                [iconOnly]="true"
                [qpxTooltip]="trailingIconLabel()"
                matTooltipPosition="above"
            />
        }
    </span>
}
